import React, { useState, useEffect } from 'react';
import { Menu, X, Instagram, Phone, Music } from 'lucide-react';
import { gymInfo } from '../data/mockData';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'nav-scrolled' : 'nav-transparent'}`}>
      <div className="container mx-auto px-5 md:px-10">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src={gymInfo.logo} 
              alt={gymInfo.name} 
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8 rtl:space-x-reverse">
            <button onClick={() => scrollToSection('home')} className="nav-link">
              בית
            </button>
            <button onClick={() => scrollToSection('services')} className="nav-link">
              שירותים
            </button>
            <button onClick={() => scrollToSection('trainers')} className="nav-link">
              המאמנים
            </button>
            <button onClick={() => scrollToSection('gallery')} className="nav-link">
              גלריה
            </button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">
              צור קשר
            </button>
          </div>

          {/* CTA + Social */}
          <div className="hidden md:flex items-center gap-4">
            <a 
              href={gymInfo.spotify}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-wood-lighter transition-colors spotify-icon"
              aria-label="Spotify"
              title="האזינו לפלייליסט שלנו"
            >
              <Music size={20} />
            </a>
            <a 
              href={gymInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:text-wood-lighter transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={20} />
            </a>
            <a 
              href={`tel:${gymInfo.phone}`}
              className="text-primary hover:text-wood-lighter transition-colors"
              aria-label="Phone"
            >
              <Phone size={20} />
            </a>
            <a 
              href={gymInfo.membershipUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              רכישת מנוי
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-primary p-2"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mobile-menu">
            <div className="flex flex-col space-y-4 pb-6">
              <button onClick={() => scrollToSection('home')} className="nav-link text-right">
                בית
              </button>
              <button onClick={() => scrollToSection('services')} className="nav-link text-right">
                שירותים
              </button>
              <button onClick={() => scrollToSection('trainers')} className="nav-link text-right">
                המאמנים
              </button>
              <button onClick={() => scrollToSection('gallery')} className="nav-link text-right">
                גלריה
              </button>
              <button onClick={() => scrollToSection('contact')} className="nav-link text-right">
                צור קשר
              </button>
              
              <div className="flex items-center gap-4 pt-4 justify-end">
                <a 
                  href={gymInfo.spotify}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary spotify-icon"
                  aria-label="Spotify"
                >
                  <Music size={24} />
                </a>
                <a 
                  href={gymInfo.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary"
                  aria-label="Instagram"
                >
                  <Instagram size={24} />
                </a>
                <a 
                  href={`tel:${gymInfo.phone}`}
                  className="text-primary"
                  aria-label="Phone"
                >
                  <Phone size={24} />
                </a>
              </div>

              {/* App Store Button - Mobile Only */}
              <a 
                href={gymInfo.appStore}
                target="_blank"
                rel="noopener noreferrer"
                className="app-store-badge"
              >
                <img 
                  src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/he-il?size=250x83&amp;releaseDate=1695772800" 
                  alt="הורד מה-App Store"
                  style={{ width: '140px', height: 'auto' }}
                />
              </a>
              
              <a 
                href={gymInfo.membershipUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary text-center"
              >
                רכישת מנוי
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
